import { ITransactionsQueryParams, ETransactionUiType } from 'src/models/transactions.model';
import { EInstrumentCategory } from '../models/common.model';
import { DraftInvestmentRoute } from 'src/models/routes.model';

export const defaultRiskLevels = [1, 2, 3, 4, 5, 6];
export const defaultInstrumentRiskLevels = [1, 2, 3, 4, 5, 6, 7];

export const availableInvestmentPeriods = [
  {
    value: '1',
    key: 'weekly',
    disabled: false,
  },
  {
    value: '4',
    key: 'monthly',
    disabled: false,
  },
  {
    value: '12',
    key: 'quarterly',
    disabled: false,
  },
];

export const newPortfolioConfig = {
  investmentNameMaxLength: 32,
  investmentNameMinLength: 3,
  timeOfInvestmentInit: 20,
}

export const instrumentCategoryColors: Record<EInstrumentCategory | string, string> = {
  EQUITY: '#E52713',
  BOND: '#781900',
  ALTERNATIVE: '#858585',
  COMODITY: '#3B3B3B',
  CASH: '#008000',
  MONEY: '#fc5017',
  REAL_ESTATE: '#4CBB17',
  LEVERAGED: '#32CD32',
  CRYPTOCURRENCY: '#2F7EEE',
  MULTI_ASSET: '#FFD700',
}

// Chart colors from Figma
export const futureDevelopmentChartColors = {
  optimistic: '#3f944b', // green
  expected: '#4096ff', // blue
  pessimistic: '#ffa940', // orange
  pureInvestment: '#888', // grey
};

export const randomColors: string[] = [
  '#262626',
  '#3fa535',
  '#b5b5b5',
]

export const maxInvestmentLength = 40; // years
export const lowestOptimizedWidthBreakpoint = 290; //px
export const smallPhoneWidthBreakpoint = 360; //px
export const regularPhoneWidthBreakpoint = 420; //px
// https://getbootstrap.com/docs/5.0/layout/breakpoints/
export const tabletWidthBreakpoint = 576; //px
export const desktopWidthBreakpoint = 768; //px
export const largeDesktopWidthBreakpoint = 992; //px
export const xlDesktopWidthBreakpoint = 1200; //px
// export const largeScreenWidthBreakpoint = 1400; //px

export const CLIENT_PEEK_ROUTE = 'client-peek';
export const NEW_CLIENT_ROUTE = 'new-client';
export const BLOG_ROUTE = 'blog';
export const ARTICLE_PREVIEW = 'preview';

export const NEW_CLIENT_ID = NaN;

export const EfektikaInstrumentWeights = {
  singleEfektikaInstrumentWeight: 98,
  efektikaCashMax: 2,
}

export const CLIENT_REDIRECT_AFTER_AUTH_ROUTES = [
  BLOG_ROUTE,
  DraftInvestmentRoute.DRAFT_INVESTMENT,
];

export const EFEKTIKA_PDF = 'Podminky_EFEKTIKA';

export const INITIAL_TRANSACTIONS_FILTERS: ITransactionsQueryParams = {
  size: 3,
  type: [
    ETransactionUiType.DEPOSIT,
    ETransactionUiType.WITHDRAWAL,
    ETransactionUiType.BUY,
    ETransactionUiType.SELL,
  ],
};

// if editing some value dont forget to change styles too
export const STYLE_VALUES_PASSED_VIA_HTML = {
  BOTTOM_NAVBAR_HEIGHT: '--liberro-native-bottom-navbar-height',
  TOP_SAFEZONE_HEIGHT: '--liberro-top-safezone-height',
  BOTTOM_SAFEZONE_HEIGHT: '--liberro-bottom-safezone-height',
  INVESTMENT_DETAIL_BOTTOM_STICKY_ACTIONS: '--liberro-detail-bottom-sticky-actions',
  INVESTMENT_TAGS_PADDING: '--liberro-investment-tags-padding',
}

export enum EWatchedResponseCodes {
  UNAUTHORIZED = 401,
  NATIVE_APP_OUTDATED = 426,
}

export const hideFinancialValues = {
  dashboardTotalBalance: '120 345 Kč',
  dashboardProfit: '+230,95 Kč',
  investmentTileValue: '98 864 Kč',
  investmentTileProfit: '+16 086 Kč',
}

export const BWM_BG_LIGHT = '#FFFFFF';
export const BWM_BG_DARK = '#171F22';
export const NO_SCROLL_CLASS = 'bwm-no-scroll';
// Direction from UI designer, in px
export const MOBILE_BOTTOM_SHEET_TOP_OFFSET = 64;
